<template>
<div class="contents">
  <admin adminType="staff" :searchPrm="searchPrm"/>
</div>
</template>
<script>
import Admin from '../Admin/AdminWashRequestList/index.vue'
export default {
  name: 'staff-wash-request-list',
  props: {
    searchPrm: {
      type: Object,
      'default': () => ({
        staffId: '',
        createdDtFrom: '',
        createdDtTo: '',
        filterWreqCreated: false,
        filterPickedUp: false,
        filterWashed: false,
        filterFolded: false,
        filterDelivered: false,
        userId: '',
        bagSize:'',
      })
    }
  },
  components: {
    Admin
  }
}
</script>
